export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 搜索列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    INDEX_ALL: function INDEX_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/index/list',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 搜索创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    INDEX_CREATE: function INDEX_CREATE(data) {
      return request({
        url: '/api/index/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    INDEX_DETAIL: function INDEX_DETAIL(id) {
      return request({
        url: '/api/index/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    INDEX_UPDATE: function INDEX_UPDATE(data) {
      return request({
        url: '/api/index/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 搜索删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    INDEX_DELETE: function INDEX_DELETE(id) {
      return request({
        url: '/api/index/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});